import {BigWinEvents} from '@fantasmagames/slot/src/modules/bigwin/BigWinEvents';
import {FreeSpinsEvents} from '@fantasmagames/slot/src/modules/freespins/intro/FreeSpinsEvents';
import {Timer} from '@fantasmagames/core/src/update/Timer';
import {Module} from '@fantasmagames/slot/src/common/Module';
import {FlowModuleEvents} from '@fantasmagames/slot/src/modules/flow/FlowModuleEvents';
import {StartScreenEvents} from '@fantasmagames/slot/src/modules/startscreen/StartScreenEvents';
import {ReelsEvents} from '@fantasmagames/slot/src/modules/reels/spin/ReelsEvents';
import {GamePrototypeLogic} from '../logic/prototype/GamePrototypeLogic';
import {SpinButtonEvents} from '@fantasmagames/slot/src/modules/keypad/spinbutton/SpinButtonEvents';
import {GameAvalancheReelsEvents} from '../avalanche/GameAvalancheReelsEvents';
import {RespinEvents} from '../respin/RespinEvents';
import {AvalancheReelsEvents} from '@fantasmagames/slot/src/modules/reels/avalanche/AvalancheReelsEvents';
import {WildMeterEvents} from '../wildmeter/WildMeterEvents';
import {GameRecodeLogic} from 'src/logic/recode/GameRecodeLogic';
import {GameWinPresentationEvents} from 'src/winpresentation/GameWinPresentationEvents';
import {WinUtils} from '@fantasmagames/slot/src/logic/WinUtils';
import {GameReelsStats} from 'src/avalanche/GameReelsStats';

export class SoundHandlerModule extends Module<null> {

	protected static readonly MUSICLEVEL_WINLIMIT_1: number = 1;
	protected static readonly MUSICLEVEL_WINLIMIT_2: number = 3;
	protected static readonly MUSICLEVEL_DELAY_UNTIL_DECREASE: number = 10000;
	protected static readonly FS_DELAY_UNTIL_MUSIC: number = 4450;

	protected _currentMusicLevel: number = 0;
	protected _musicLevelTimer: Timer;
	protected _fsTimer: Timer;
	protected _isFSIntroStarted: boolean = false;

	protected _isBigWinInProgress: boolean = false;

	public restore(): void {
		super.restore();
	}

	protected enterFirstState(): void {
	}

	protected setupStates(): void {
	}

	protected setupViews(): void {
	}

	protected setupEvents(): void {

		this.on(StartScreenEvents.INTRO_STARTED, this.onGameIntroStarted);
		this.on(StartScreenEvents.EXIT_FINISHED, this.onGameStarted);

		this.on(SpinButtonEvents.SPIN_BUTTON_PHYSICALLY_CLICKED, this.onSpinButtonPressed);
		this.on(SpinButtonEvents.SPIN_BUTTON_SPACE_PHYSICALLY_CLICKED, this.onSpinButtonPressed);
		this.on(SpinButtonEvents.QUICKSTOP_PRESSED, this.onQuickstopPressed);

		this.on(ReelsEvents.REELS_SPINNING_STARTED, this.onDropOutSymbols);
		this.on(AvalancheReelsEvents.ALL_REELS_DROP_NEW_STARTED, this.onDropInSymbols);
		this.on(GameAvalancheReelsEvents.FILLING_VOIDS_STARTED, this.onFillingVoids);
		this.on(GameAvalancheReelsEvents.WIN_HIGHLIGHTING_FINISHED, this.onUpdateMusicLevel); // TODO: Change to symbol drop event
		this.on(GameAvalancheReelsEvents.WIN_HIGHLIGHTING_STARTED, this.killMusicLevelTimer);
		this.on(RespinEvents.RESPIN_STARTED, this.killMusicLevelTimer);
		this.on(ReelsEvents.ALL_REELS_STOPPED, this.onAllReelsStopped);

		this.on(GameAvalancheReelsEvents.WIN_SYMBOLS_EXPLOSION_STARTED, this.onRemoveSymbols);

		this.on(WildMeterEvents.ADD_WILD_COIN_TO_REELS, this.onAddWildCoinToReels);
		this.on(WildMeterEvents.SEND_COIN_TO_METER, this.onSendCoinToMeter);
		this.on(WildMeterEvents.COIN_HIT_METER, this.onCoinHitMeter);
		this.on(WildMeterEvents.MULTIPLIER_UDPATE, this.onMultiplierUpdate);
		this.on(WildMeterEvents.INDICATOR_LIT, this.onMultIndicatorLit);
		this.on(WildMeterEvents.WIN_METER_EXIT_WIN_ANIMATION_STARTED, this.onMultFlyToWin);

		this.on(GameAvalancheReelsEvents.WIN_HIGHLIGHTING_WINLINE, this.onLineWin);
		this.on(GameAvalancheReelsEvents.WIN_HIGHLIGHTING_STARTED, this.onInitialWinStarted);
		this.on(GameAvalancheReelsEvents.WIN_HIGHLIGHTING_FINISHED, this.onInitialWinFinished);
		this.on(GameWinPresentationEvents.COUNTING_STARTED, this.onWinPresentationCountingStarted);
		this.on(GameWinPresentationEvents.AFTER_MULTIPLIER_COUNTING_FINISHED, this.onWinPresentationCountingFinished);

		this.on(BigWinEvents.ON_BEFORE_BIG_WIN, this.onBeforeBigWin);
		this.on(BigWinEvents.COUNTUP_FINISHED, this.onBigWinFinished);
		this.on(BigWinEvents.TRANSITION_STARTED, this.onBigWinThreshold);

		this.on(RespinEvents.RESPIN_STARTED, this.onRespinStarted);
		this.on(RespinEvents.LEAVING_SYMBOL_AT, this.onRespinHit);
		this.on(RespinEvents.END_ANIM_TRIGGERED, this.onRespinEnd);

		this.on(GameAvalancheReelsEvents.SCATTER_ATTENTION_TRIGGERED, this.onScatterAttention);
		this.on(GameAvalancheReelsEvents.RESPIN_ATTENTION_TRIGGERED, this.onRespinAttention);

		this.on(FreeSpinsEvents.FREE_SPINS_INTRO_STARTED, this.onFreeSpinsIntroStarted);
		this.on(FreeSpinsEvents.FREE_SPINS_OUTRO_STARTED, this.onFreeSpinsOutroStarted);
		this.on(FreeSpinsEvents.FREE_SPINS_OUTRO_FINISHED, this.onFreeSpinsOutroFinished);
		this.on(FreeSpinsEvents.FREE_SPINS_START_READY, this.onFreeSpinsStartReady);
		this.on(FreeSpinsEvents.FREE_SPINS_CONTINUE_CLICKED, this.onFreeSpinsContinueClicked);
		this.on(FreeSpinsEvents.FREE_SPINS_RETRIGGER_STARTED, this.onFreeSpinsRetriggerStarted);

		// this.on(GameBackgroundEvents.VIEW_TRANSITION_TO_MAINGAME_COMPLETED, this.onViewTransitionToMainGameCompleted);

		this.on(FlowModuleEvents.CAN_SPIN, this.onSpinEnded);
	}

	// protected onViewTransitionToMainGameCompleted(): void {
	//     this.soundPlayer.fadeCurrentMusicTo(`mainMusic1`, 1000);
	// }

	protected onDropOutSymbols(): void {
		this.soundPlayer.play('reelsFallOut');
	}

	protected onDropInSymbols(): void {
		const soundId: string = GameReelsStats.IS_ON_REGULATED_MARKET ? 'reelsFallIn3sec' : 'reelsFallIn';
		this.soundPlayer.play(soundId);
	}

	protected onFillingVoids(): void {
		const soundId: string = 'reelsFallIn';
		const minVoids: number = 3;
		const maxVoids: number = 15 - minVoids;
		const numVoids: number = this.logic.getSpinResult().symbolsToRemove && this.logic.getSpinResult().symbolsToRemove.length - minVoids;

		this.soundPlayer.play(soundId);

		/* Shorten sound based on number of symbols falling down */
		if (numVoids >= 0 && numVoids < maxVoids) {
			const soundLength: number = 1280;
			const fadeOutDuration: number = 250;
			const minDelay: number = 150;

			const fadeOutDelay: number = minDelay + (numVoids / maxVoids * (soundLength - minDelay - fadeOutDuration));

			this.timeUtils.createTimer(() => {
				this.soundPlayer.stopFadeSound(soundId, fadeOutDuration, null);
			}, fadeOutDelay);
		}
	}

	protected onSpinEnded(): void {
		this.startMusicLevelTimer();
	}

	private startMusicLevelTimer(): void {
		if (this._musicLevelTimer || this._currentMusicLevel < 2 || this.logic.isFreeSpinsStarted
			|| this._isFSIntroStarted) {
			return;
		}

		this._musicLevelTimer = this.timeUtils.createTimer(() => {
			this._currentMusicLevel -= 1;
			this.soundPlayer.fadeCurrentMusicTo(`mainMusic${this._currentMusicLevel}`, 1000);
			this.killMusicLevelTimer();
			this.startMusicLevelTimer();
		}, SoundHandlerModule.MUSICLEVEL_DELAY_UNTIL_DECREASE);
	}

	protected killMusicLevelTimer(): void {
		if (this._musicLevelTimer) {
			this._musicLevelTimer.stop();
			this._musicLevelTimer = null;
		}
	}

	protected onUpdateMusicLevel(): void {
		const logic: GamePrototypeLogic = this.logic as GamePrototypeLogic;

		if (logic.isFreeSpinsStarted) {
			return;
		}

		const totalWinTimesBet: number = logic.getNextAvalancheRunningTotalInCents() / logic.getTotalBet();
		const musicLevel: number = totalWinTimesBet >= SoundHandlerModule.MUSICLEVEL_WINLIMIT_2 ? 3 :
			totalWinTimesBet >= SoundHandlerModule.MUSICLEVEL_WINLIMIT_1 ? 2 : 1;

		if (musicLevel > this._currentMusicLevel) {
			this.soundPlayer.fadeCurrentMusicTo(`mainMusic${musicLevel}`, 1000);
			this._currentMusicLevel = musicLevel;
		}
	}

	protected onAllReelsStopped(): void {
	}

	protected onFreeSpinsStartReady(): void {
	}

	private startFsTimer(): void {
		if (this._fsTimer) {
			return;
		}

		this._fsTimer = this.timeUtils.createTimer(() => {
			this.startFreeSpinsMusic();
		}, SoundHandlerModule.FS_DELAY_UNTIL_MUSIC);
	}

	protected killFsTimer(): void {
		if (this._fsTimer) {
			this._fsTimer.stop();
			this._fsTimer = null;
		}
	}

	protected onFreeSpinsIntroStarted(): void {
		this._isFSIntroStarted = true;
		this.killMusicLevelTimer();

		this.soundPlayer.fadeCurrentMusic(1000);
		this.soundPlayer.play('freeSpinsIntro');

		this.startFsTimer();
	}

	protected onFreeSpinsContinueClicked(): void {
		if (!this._fsTimer) { // Music already started
			return;
		}

		this.startFreeSpinsMusic();
	}

	protected onFreeSpinsRetriggerStarted(): void {
		this.soundPlayer.play('winRetrigger');
	}

	protected startFreeSpinsMusic(): void {
		this.killFsTimer();
		this.soundPlayer.stopMusic();
		this.soundPlayer.playMusic('freeSpinsMusic');
	}

	protected onFreeSpinsOutroStarted(): void {
		this.soundPlayer.fadeCurrentMusic(1000);
		this.soundPlayer.play('freeSpinsOutro');
	}

	protected onFreeSpinsOutroFinished(): void {
		this._isFSIntroStarted = false;
		this.soundPlayer.stopMusic();
		this.soundPlayer.fadeCurrentMusicTo('mainMusic1');
	}

	protected onGameIntroStarted(): void {
		this.soundPlayer.play('gameIntro');
	}

	protected onGameStarted(): void {
		const logic: GamePrototypeLogic = this.logic as GamePrototypeLogic;

		if (logic.isFreeSpinsStarted && logic.hasRestore) {
			this.soundPlayer.fadeCurrentMusicTo('freeSpinsMusic', 1000);
		} else {
			this.soundPlayer.fadeCurrentMusicTo(`mainMusic1`, 1000);
		}
	}

	private onSpinButtonPressed(): void {
		this.soundPlayer.play('spinBtnStart');
	}

	private onQuickstopPressed(): void {
		this.soundPlayer.play('spinBtnQuickStop');
	}

	private onRemoveSymbols(): void {
		this.soundPlayer.play('reelsRemove');
	}

	private onLineWin(event: string, isRightToLeft: boolean): void {
		this.soundPlayer.play('winLine' + (isRightToLeft ? 'R' : 'L'));
	}

	private onInitialWinStarted(): void {
		this.soundPlayer.play('winCountup', true);
	}

	private onInitialWinFinished(): void {
		this.soundPlayer.stopFadeSound('winCountup', 300, null);
	}

	private onBeforeBigWin(): void {
		this._isBigWinInProgress = true;

		this.soundPlayer.duckMusic(1000);
		this.soundPlayer.play('bigwinBuildup');
		this.timeUtils.createTimer(() => {
			if (this._isBigWinInProgress) {
				this.soundPlayer.play('bigwinLoop');
			}
		}, 750);
	}

	private onBigWinThreshold(): void {
		this.soundPlayer.play('bigwinThreshold');
	}

	protected onBigWinFinished(): void {
		this._isBigWinInProgress = false;
		this.soundPlayer.stopFadeSound('bigwinLoop', 300, null);
		this.soundPlayer.play('bigwinEnd');

		this.soundPlayer.unduckMusic(2600);
	}

	private onRespinAttention(): void {
		this.soundPlayer.play('respinAttention');
	}

	private onRespinStarted(): void {
		this.soundPlayer.play('respinActivate');
		this.soundPlayer.play('respinMove');
	}

	private onRespinHit(): void {
		const soundId: string = 'respinHit' + (Math.floor(Math.random() * 3) + 1);
		this.soundPlayer.play(soundId);
	}

	private onRespinEnd(): void {
		this.soundPlayer.play('respinEnd');
	}

	private onScatterAttention(event: string, scatterIndex: number): void {
		const soundId: string = 'scatterAttention' + Math.min(scatterIndex, 3);
		this.soundPlayer.play(soundId);
	}

	private onAddWildCoinToReels(): void {
		this.timeUtils.createTimer(() => {
			this.soundPlayer.play('multWildBreak');
		}, 750);
	}

	private onSendCoinToMeter(): void {
		this.soundPlayer.play('multCollectFly');
	}

	private onCoinHitMeter(): void {
		this.soundPlayer.play('multCollectHit');
	}

	private onMultiplierUpdate(): void {
		const logic: GameRecodeLogic = this.logic as GameRecodeLogic;

		const soundID: string = logic.isFreeSpinsStarted ? 'multUpdateFs' : 'multUpdate';
		this.soundPlayer.play(soundID);
	}

	private onMultIndicatorLit(): void {
		this.soundPlayer.play('multCollectIndicator');
	}

	private onMultFlyToWin(): void {
		this.soundPlayer.play('multWin');
	}

	protected onWinPresentationCountingStarted(eventId: string, value: number, playCountUpSound: boolean = false): void {
		if (value >= this.logic.getTotalBet() * WinUtils.NICE_WIN_ONE_ROUND_THRESHOLD_HIGH) {
			// isExcellent
			this.soundPlayer.play('winExcellent');
			playCountUpSound && this.soundPlayer.play('winCountup', true);
		} else if (value >= this.logic.getTotalBet() * WinUtils.NICE_WIN_ONE_ROUND_THRESHOLD_LOW) {
			// isNice
			this.soundPlayer.play('winNice');
			playCountUpSound && this.soundPlayer.play('winCountup', true);
		} else {
			// normal
			this.soundPlayer.play('winNormal');
		}

	}

	protected onWinPresentationCountingFinished(): void {
		this.soundPlayer.stopFadeSound('winCountup', 300, null);
	}
}


// WEBPACK FOOTER //
// ./src/sound/SoundHandlerModule.ts